import { updateSitesSettings } from "../../settingsService";
import { getAllowedStoresList } from "../../storeService";
import { BaseSettingsService } from "./BaseSettingsService";

export class StoreSettingsService extends BaseSettingsService {
    async getSettings() {
        const adminStoreNumber = 1;
        try {
            const response = await getAllowedStoresList(adminStoreNumber);
            return response.Items;
        } catch (error) {
            throw error;
        }
    }

    async updateSetting({value, settingSelected}) {
        try {
            const params = {
                settingSelected: settingSelected.tablePropertyName,
                value: value
            };
            if (Array.isArray(value)) {
                params.value = "list";
                params.body = { values: value };
            }
            const response = await updateSitesSettings(params);
            return {settingValue: params.value, response };
        }
        catch(error){
            throw error;
        }
    }

    mapResponseToLocalValue({settingsData, settingSelected, settingsDictionary}, settingValue ) {
        return settingsData.map((category) => ({
            ...category,
            data: category.data.map((setting) =>
                // Check if this is the setting being updated.
                setting.propertyName === settingSelected.propertyName ||
                setting.label === settingSelected.label
                ? {
                    ...setting,
                    currentValue: settingsDictionary[settingValue],
                }
                : setting
            ),
        }));
    }
}